import { ThemeStyles } from 'theme-ui'

export const styles: ThemeStyles = {
  root: {
    margin: 0,
    fontFamily: 'body',
    fontWeight: 'body',
    lineHeight: 'body',
  },
  a: {
    color: 'text',
    textDecoration: 'none',
    fontWeight: 'bold',
    '&:hover': {
      color: 'red',
    },
  },
  h2: {
    fontWeight: 300,
  },
}
